import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { StartSecureLinkVerificationResponseType } from './startSecureLinkVerificationApi';

export const resendSecureLinkVerificationApi = (
  token: string
): Promise<ApiResponseType<StartSecureLinkVerificationResponseType>> => {
  return apiService.POST(`/secure-links/${token}/verify/resend/`, {});
};
